package br.com.texeratx.boardgametimeapp.core.utils

import kotlin.js.Date

actual fun currentTimeMillis(): Long = Date().getTime().toLong()
